import {
  doc,
  getDoc,
  setDoc,
  collection,
  query,
  where,
  onSnapshot
} from 'firebase/firestore'
import {
  ref,
  uploadBytesResumable,
  getDownloadURL,
  deleteObject
} from 'firebase/storage'
import { db, user, storage } from '../firebase'
import { Task } from './task'
import { Charge } from './charge'
import { Notification } from './notification'
import { Transaction } from './transaction'
import { Utils } from '../utils'
import { readable } from 'svelte/store'
export class User {
  constructor (userObj) {
    return (async () => {
      this.auth = userObj
      this.doc = await User.realTimeProfile(this.auth.claims.store)
      this.charges = Charge.realTime(this.auth.claims.store)
      this.tasks = Task.realTime(this.auth.claims.store)
      this.notifications = Notification.realTime(this.auth.claims.store)
      this.transactions = Transaction.realTime(this.auth.claims.store)
      return this
    })()
  }

  update = {
    task: (
      data = {
        comment_id: {},
        attachment: '',
        comment_text: '',
        role: '',
        username: ''
      },
      id
    ) => {
      return Task.update(this.auth.claims.store, data, id)
    },
    profile: (
      data = { name: '', lastname: '', email: '', phone: '', img: '' }
    ) => {
      const ref = doc(db, 'stores/' + this.auth.claims.store)
      return setDoc(ref, data, { merge: true })
    }
  }

  create = {
    task: (
      id,
      data = {
        name: '',
        details: '',
        priority: '',
        attachments: [],
        taskid: {},
        messages: {}
      }
    ) => {
      return Task.create(this.auth.claims.store, id, data)
    },
    uptask: (
      data = {
        comment_id: {},
        attachment: '',
        comment_text: '',
        role: '',
        username: ''
      },
      id
    ) => {
      return Task.update(this.auth.claims.store, data, id)
    },
    file: (file, callback) => {
      return new Promise(async (resolve, reject) => {
        let fileInStorageName = Utils.nanoid() + '-' + file.name
        const storageRef = ref(
          storage,
          'stores' + '/' + this.auth.claims.store + '/' + fileInStorageName
        )
        const metadata = {
          name: file.name
        }
        const uploadTask = uploadBytesResumable(storageRef, file, metadata)
        uploadTask.on(
          'state_changed',
          snapshot => {
            /* interim state */
            /* listen to callback to get progress */
            const progress = (
              (snapshot.bytesTransferred / snapshot.totalBytes) *
              100
            ).toFixed(2)
            callback(progress)
          },
          error => {
            /* error occured */
            console.error(error)
          },
          () => {
            /* finished */

            getDownloadURL(uploadTask.snapshot.ref).then(downloadURL => {
              resolve({
                name: fileInStorageName,
                token: Utils.file.linkToToken(downloadURL)
              })
            })
          }
        )
      })
    },
    charge: (
      id,
      data = {
        name: '',
        price: 0,
        status: '',
        confirmation_url: '',
        api_client_id: 0
      }
    ) => {
      return Charge.create(this.auth.claims.store, id, data)
    }
  }

  delete = {
    file: path => {
      const storageRef = ref(storage, path)
      return deleteObject(desertRef)
    }
  }

  static fromAuth (userObj) {
    return new User(userObj)
  }
  static async realTimeProfile (shop) {
    const ref = doc(db, '/stores/' + shop)
    return readable((await getDoc(ref)).data(), set => {
      const unsubscribeSnapshot = onSnapshot(ref, doc => {
        const data = doc.data()
        console.log(doc)
        console.log(data)
        set(data)
      })
      return () => unsubscribeSnapshot
    })
  }
}
